// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_CER,
  ADD_CER,
  UPDATE_CER,
  DELETE_CER,
  REQUEST_CER,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getCers = ({ dispatch }, contactId) => {
  dispatch(REQUEST_CER)
  return new Promise((resolve, reject) => {
    Vue.http
      .get('cer/contact/' + contactId)
      .then(
        (response) => {
          dispatch(GET_CER, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}

/**
 * Add a new cer
 * @param dispatch
 * @param cer
 */
export const addCer = ({ dispatch }, cer) => {
  dispatch(REQUEST_CER)
  Vue.http
    .post('cer', cer)
    .then(
      (response) => {
        let data = response.json()
        dispatch(ADD_CER, data)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Edit a cer
 *
 * @param dispatch
 * @param oldContact The former cer data
 * @param newContact The new cer data
 */
export const editCer = ({ dispatch }, oldCer, newCer) => {
  dispatch(REQUEST_CER)
  Vue.http
    .put('cer/' + newCer.id, newCer)
    .then(
      (response) => {
        dispatch(UPDATE_CER, oldCer, newCer)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Delete a cer
 *
 * @param dispatch
 * @param cer
 */
export const deleteCer = ({ dispatch }, cer) => {
  dispatch(REQUEST_CER)
  Vue.http.delete('cer/' + cer.id)
    .then(
      (response) => {
        dispatch(DELETE_CER, cer)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}



// WEBPACK FOOTER //
// ./src/vuex/actions/cerActions.js